
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

export default function Gallery({ galleryImages }) {
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();

    const imgCounter = (e) => {
        if (e === 1) {
            return 1;
        }
        else if (e === 2) {
            return 2;
        }
        else if (e === 3) {
            return 3;
        }
        else if (e === 4) {
            return 4;
        }
        else if (e === 5) {
            return 5;
        }
        else if (e >= 6) {
            return 6;
        }
    };

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 500px)").matches
    );

    useEffect(() => {
        window
            .matchMedia("(min-width: 500px)")
            .addEventListener('change', e => setMatches(e.matches));
    }, []);
    

    return (
        <div>
            <Slider asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
                {
                    galleryImages.map((item, i) => (
                        <div key={i} className='h-auto w-auto'>
                            <Zoom>
                                <img
                                    alt="That Wanaka Tree, New Zealand by Laura Smetsers"
                                    src={item.base64}
                                    width="500"
                                />
                            </Zoom>
                            {/* <img className='w-full object-contain h-full' src={item.base64} alt="" /> */}
                        </div>
                    ))
                }
            </Slider>
            {galleryImages.length > 1 && <Slider
                asNavFor={nav1}
                ref={(slider2) => setNav2(slider2)}
                slidesToShow={matches ? imgCounter(galleryImages.length) : 3}
                swipeToSlide={true}
                focusOnSelect={true}
            >
                {
                    galleryImages.map((item, i) => (
                        <div key={i} className='h-auto w-auto px-1'>
                            <img className='w-full object-contain h-full' src={item.base64} alt="" />
                        </div>
                    ))
                }
            </Slider>}
        </div>
    );
}